export default __webpack_public_path__ + "static/media/doll.aa979089.png";